import React from "react"
import { NavLink } from "react-router-dom"
import { useLocation } from "react-router-dom"

const locations = [
  {
    image: require("./../../images/our-history/4.jpg"),
    title: "ABOUT US",
    location: "We are competitive in architecture solutions",
    description:
      "Innen is a multidisciplinary design and engineering studio specializing in interior design, turnkey execution, and BIM services. We create refined, functional spaces with a focus on quality, innovation, and coordination. From concept to delivery, we blend creative vision with technical expertise to bring your spaces to life.",
  },
  // {
  //     image: require('./../../images/our-history/1.jpg'),
  //     title: 'Art Museum',
  //     location: 'Muscat, Sultanate of Oman.',
  //     description: 'Fantastic service from start to finish. After our ceiling collapsed we never thought our damaged floor would look so good again. These guys worked in a tight time frame and were very accommodating to the other trades working in the same area to produce brilliant results and restore our badly damaged floor to look like new!',
  // },
  // {
  //     image: require('./../../images/our-history/2.jpg'),
  //     title: 'Drana Villa, CA',
  //     location: 'Amman, Jordan',
  //     description: 'The floor looks magnificent and the parquet in the hall sets it off beautifully. Your men were excellent, you were delightful and nothing was too much trouble for you. You have very tidy workers, covering everything, and the house was left in a good shape as the condition allowed.',
  // },
  // {
  //     image: require('./../../images/our-history/3.jpg'),
  //     title: 'House Office, CA',
  //     location: 'Casablanca, Morocco',
  //     description: 'I just wanted to say thank you and the team very much for the brilliant service around renovating the floors at our house. You were absolutely brilliant and we can see you’ve gone the extra mile matching the floors between rooms etc. You’ve kept the place really tidy too, cannot ask for more.',
  // },
  // {
  //     image: require('./../../images/our-history/5.jpg'),
  //     title: 'French Embassy',
  //     location: 'Perth, Australia',
  //     description: 'I just wanted to say thank you and the team very much for the brilliant service around renovating the floors at our house. You were absolutely brilliant and we can see you’ve gone the extra mile matching the floors between rooms etc. You’ve kept the place really tidy too, cannot ask for more.',
  // },
  // {
  //     image: require('./../../images/our-history/6.jpg'),
  //     title: 'Art Museum',
  //     location: 'Muscat, Sultanate of Oman.',
  //     description: 'Fantastic service from start to finish. After our ceiling collapsed we never thought our damaged floor would look so good again. These guys worked in a tight time frame and were very accommodating to the other trades working in the same area to produce brilliant results and restore our badly damaged floor to look like new!',
  // },
  // {
  //     image: require('./../../images/our-history/7.jpg'),
  //     title: 'Drana Villa, CA',
  //     location: 'Amman, Jordan',
  //     description: 'The floor looks magnificent and the parquet in the hall sets it off beautifully. Your men were excellent, you were delightful and nothing was too much trouble for you. You have very tidy workers, covering everything, and the house was left in a good shape as the condition allowed.',
  // },
  // {
  //     image: require('./../../images/our-history/8.jpg'),
  //     title: 'House Office, CA',
  //     locatio: 'Casablanca, Morocco',
  //     description: 'I just wanted to say thank you and the team very much for the brilliant service around renovating the floors at our house. You were absolutely brilliant and we can see you’ve gone the extra mile matching the floors between rooms etc. You’ve kept the place really tidy too, cannot ask for more.',
  // }
]

var bgimg1 = require("./../../images/background/cross-line.png")

const About4 = () => {
  const location = useLocation()
  // console.log(location.pathname)

  return (
    <>
      <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
        <div className="container">
          <div className="section-content ">
            <div className="our-history text-black">
              {locations.map((item, index) => (
                <div className="row" key={index}>
                  <div className="col-12 pic-bg-border">
                    <div
                      className="our-history-pic bg-no-repeat bg-center bg-cover"
                      data-stellar-background-ratio="0.5"
                      style={{ backgroundImage: `url(${item.image})` }}
                    ></div>
                  </div>
                  <div className="col-12">
                    <div className="our-history-content m-b30">
                      <div className="large-title ">
                        <div className="section-head">
                          <div className="sx-separator-outer separator-left">
                            <div
                              style={{
                                backgroundImage: `url(${bgimg1})`,
                                width: "100%",
                              }}
                            >
                              <h3
                                className="sep-line-one"
                                style={{ textTransform: "uppercase" }}
                              >
                                {item.title}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <h4>{item.location}</h4>
                      </div>
                      <p className="mb-4">{item.description}</p>
                      <NavLink
                        to={
                          location?.pathname === "/about"
                            ? "/services-1"
                            : "/about"
                        }
                        className="site-button-secondry btn-half"
                      >
                        <span> Read More</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              ))}
              {/* Optional Load More Button */}
              {/* <div
                className="text-center load-more-btn-outer"
                style={{ backgroundImage: `url(${bgimg1})` }}
              >
                <button
                  id="loadMorebtn-5"
                  className="site-button-secondry btn-half"
                >
                  <span>Load More</span>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About4
